export class BlobTransferModel {
  total: number = 0;
  transfered: number = 0;
  progress: number = 0;

  durationMs: number = 0;
  estimatedTimeLeftMs: number = 0;
}
